import axios from 'axios';
import store from '../store'
import analytics from '../utils/analytics'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ?
  'https://api.provisor.kz' :
  'http://localhost:65186'

axios.defaults.withCredentials = true

axios.interceptors.request.use(function (config) {
  config.headers.Authorization = `Bearer ${store.getters.ACCESS_TOKEN}`;
  // Аналитика: id сессии на каждом запросе; накопленные события — заголовком X-Analytics на ближайшем
  // обычном запросе (не на /Token/*). Повтор запроса после 401 переиспользует config с тем же заголовком —
  // дубли отбросит сервер по eventId. См. utils/analytics.js.
  // Запросы с cancelToken пропускаем: отменённый запрос (уход с Главной до ответа дашборда, смена периода)
  // в axios 0.21 попадает в interceptor ошибок без config, и события из его заголовка терялись —
  // переход «Потребность → Главная» не доезжал до БД. Такие события уедут со следующим обычным запросом.
  config.headers['X-Session-Id'] = analytics.getSessionId();
  const url = config.url || '';
  if (!url.startsWith('/Token') && !config.cancelToken && !config.headers['X-Analytics']) {
    const analyticsHeader = analytics.takeForHeader();
    if (analyticsHeader) config.headers['X-Analytics'] = analyticsHeader;
  }
  return config;
});

let subscribers = []
let isRefreshing = false

function onAccessTokenFetched() {
  subscribers = subscribers.filter(callback => callback())
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

axios.interceptors.response.use(function (response) {
  // события из заголовка доставлены
  analytics.ackHeader(response.config && response.config.headers && response.config.headers['X-Analytics']);
  return response
}, (error) => {
  window.console.log(error)

  // Аналитика: сеть/5xx — события из заголовка вернуть в очередь; 401 — не трогать (запрос повторится
  // с тем же заголовком); прочие 4xx — сервер ответил, считаем доставленными
  const analyticsHeader = error.config && error.config.headers && error.config.headers['X-Analytics'];
  if (analyticsHeader) {
    const analyticsStatus = error.response && error.response.status;
    if (!error.response || analyticsStatus >= 500) analytics.requeueHeader(analyticsHeader);
    else if (analyticsStatus !== 401) analytics.ackHeader(analyticsHeader);
  }

  let Snackbar = {
    text: 'Пожалуйста проверьте соединение с интернетом',
    timeout: 3000,
    color: "error",
    show: true
  }

  // запрос отменён самим приложением (CancelToken при уходе со страницы, см. Home.vue) — это не ошибка, snackbar не нужен
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  if (typeof error.response === 'undefined') {
    store.commit('SET_SNACKBAR', Snackbar);
    return Promise.reject(error);
  }

  switch (error.response.status) {

    case 401: {


      let Token = {
        Access: store.getters.ACCESS_TOKEN,
        Refresh: store.getters.REFRESH_TOKEN
      }

      if (!isRefreshing) {
        isRefreshing = true
        store.dispatch("UPDATE_TOKENS", Token).then(() => {
          isRefreshing = false
          onAccessTokenFetched()
        }).catch(() => {
          isRefreshing = false
          store.dispatch("CLEAR_TOKENS")
        })
      }
      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(() => {
          resolve(axios(error.response.config))
        })
      })
      return retryOriginalRequest
    }

    case 400: {
 
      if (error.response.data.errors)
        return Promise.reject(error);
      Snackbar.text = error.response.data.error;
      store.commit('SET_SNACKBAR', Snackbar);
      return Promise.reject(error);
    }

    case 403: {
      Snackbar.text = 'У вас нет доступа к этому ресурсу.';
      store.commit('SET_SNACKBAR', Snackbar);
      return Promise.reject(error);
    }

    default: {
      Snackbar.text = error.response.status;
      store.commit('SET_SNACKBAR', Snackbar);
      return Promise.reject(error);
    }
  }
})

export default 'axios';